import { Button, Text, Flex, Box } from '@chakra-ui/react';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import React, { ReactElement } from 'react';
import { Breakpoints } from 'types/breakpoints';
import { ModalDislikeVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalDislikeVariantProps;

export const DislikeModal = ({ handleClose, isShown, name, onAccept }: Props): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);
  const handleAccept = async (): Promise<void> => {
    if (onAccept) await onAccept();
    handleClose();
  };
  return (
    <CustomModal
      isOpen={isShown}
      onClose={handleClose}
      placement="center"
      size="md"
      hideHeader={!isDesktop}
    >
      <CustomModalContent
        p={{ base: '0', md: '40px 40px 30px' }}
        display="flex"
        flexDirection="column"
      >
        <Box
          p={{ base: 'l', md: '0' }}
          textAlign={{ base: 'center', md: 'left' }}
          mb={{ md: '30px' }}
        >
          <Text>&quot;{name}&quot; wirklich aus den Favoriten entfernen?</Text>
        </Box>
        <Flex
          justifyContent="flex-end"
          w="full"
          h={{ base: '60px', md: 'fit-content' }}
          borderTop={{ base: 'default', md: 'none' }}
          borderColor="border.accent"
          p="0"
        >
          <Button variant="tertiary" onClick={handleClose}>
            Zurück
          </Button>
          <Button variant="destructive" onClick={handleAccept}>
            Löschen
          </Button>
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
